module.exports = "pegasus_template/assets/tech/realty/100.png";